import React, { Component } from "react";
import style from "./Notifications.module.css";
import api from "../../utils/Api";
import { connect } from "react-redux";
import { fetchNotificationsListing, readNotifications } from "../../redux";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import stockIC from "../../assets/images/notification-inventory-icon.svg";
import approvalIC from "../../assets/images/notification-approval-icon.svg";
import appointmentsIC from "../../assets/images/notification-appointments.svg";
import dashboardNotesIC from "../../assets/images/notification-dashboard-notes.svg";
import paymentsIC from "../../assets/images/notification-payments.svg";
import userManagementIC from "../../assets/images/notification-user-management.svg";
import contactApprovalIC from "../../assets/images/notification-contact-approval-icon.svg";
import { Link, Redirect } from "react-router-dom";
import  moment  from "moment";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import history from "../../utils/history";


function dateFormatter(cell) {
    if (!cell) {
      return "";
    }
    return `${
      moment(cell).format("YYYY-MM-DD")
        ? moment(cell).format("YYYY-MM-DD")
        : moment(cell).format("YYYY-MM-DD")
    }`;
  }

export class Notifications extends Component {
    constructor(props) {
        super(props);

        this.state = {
            page:1,
            error: false,
            hasMore: true,
            isDataFetched: true,
            notifications: [],
        };
    }

    componentDidMount = async() => {
        document.title = 'Notifications - TechToMedix';
        await this.props.fetchNotificationsListing(this.state.page);
      setTimeout(() => {
        this.setState({
          isDataFetched: true,
        });
      }, 1000);
    }

    // callNotificationAPI = () => {
    //     this.setState({ 
    //         isDataFetched: false,
    //      }, async() => {
    //        await this.props.fetchNotificationsListing(this.state.page);
            
    //        if(this.props.notificationsData.notifications &&
    //         this.props.notificationsData.notifications.notification){
      
    //             this.setState({
    //               hasMore: (this.state.notifications.length < this.props.notificationsData.notifications.total),
    //               isDataFetched: true,
    //               notifications:  this.props.notificationsData.notifications.notification,
    //             });
    //         }
    //       });

    // }

    

    readNotification = async(notification) => {
        if(!notification.isRead){
            await this.props.readNotifications(notification.notification_id);

            if(this.props.readNotificationsData && 
                this.props.readNotificationsData.readNotification && 
                this.props.readNotificationsData.readNotification.isRead){  
                await this.props.fetchNotificationsListing(this.state.page);
            }

        }
         //history.push(this.getrediRectionLink(notification));
         this.props.history.push({
            pathname: this.getrediRectionLink(notification),
            state: { fromNotifications: 1 }
          })
    }
    setLoader() {
        if (this.state.isDataFetched) {
          return <p>There is no notification to display</p>;
        } else {
          return (
            <div>
              <img src={ttmLoader} alt="loader" className="loader-image" />
            </div>
          );
        }
      }
      
  onPageChange = (page, sizePerPage) => {
    this.setState({
       page, 
       isDataFetched: false 
      }, async() => {
        await this.props.fetchNotificationsListing(this.state.page);
    });
  };

  getrediRectionLink = (data) => {
    let link = "/app/notificationsboard";
    switch(data.type){
        case "Dashboard Note":
            link = "/app/dashboard";
        break;

        case "Pending Approval":
            link = "/app/pendingapprovallist";
        break;

        case "Deletion Approval":
            link = "/app/parties-delete-entries";
        break;

        case "Appointment Rescheduled":
            link = "/app/appoinmentlist";
        break;

        case "Appointment Confirmed":
            link = "/app/appoinmentlist";
        break;

        case  "Patient Cancelled Appointment":
            link = "/app/appoinmentlist";
        break;

        case "Appointment Cancelled":
            link = "/app/appoinmentlist";
        break;

        case "Inventory":
            link = "/app/inventorylist";
        break;

        case "SubCategory Created":
            link = "/app/subcategorieslist";
        break;

        case "Payment":
            link = "/app/paymenthistory";
        break;

        default:
            break;

    }
    return link;
  
    }

    getImage = (data) => {
        switch(data.type){
            case "Dashboard Note":
                return dashboardNotesIC;
            break;
    
            case "Pending Approval":
                return approvalIC;
            break;
    
            case "Deletion Approval":
                return contactApprovalIC;
            break;
    
            case "Appointment Rescheduled":
                return appointmentsIC;
            break;

            case "Appointment Confirmed":
                return appointmentsIC;
            break;

            case "Appointment Cancelled" :
                return appointmentsIC;
            break;

            case "Patient Cancelled Appointment" :
                return appointmentsIC;
            break;
    
            case "Inventory":
                return stockIC;
            break;
    
            // case "SubCategory Created":
            //     return "";
            // break;
    
            case "Payment":
                return paymentsIC;
            break;
    
            default:
                return stockIC;
                break;
    
        }
      
    }

    contentformatter = (cell,row) => {
        let element = row;
        return (
            <div className="row" onClick={() => this.readNotification(element)}>
                <div className="col-md-12 mb-3">
                    {/* <div className={`${style.notificationBox} ${element.isRead ? style.notificationReadBox : style.notificationUnReadBox}`}>
                        <div className={`col-md-1 ${style.notificationType}`}>
                            <img src={this.getImage(element)} alt="notificationtype" />
                        </div>
                        <div className={`col-md-10 ${style.textNotification}`}>
                            <div className="col-md-12">
                                <label>{element.type} - {dateFormatter(element.created_at)}</label>
                            </div>
                            <div className="col-md-12">
                                <p>{element.message}</p>
                            </div>
                        </div>
                        <div className={`col-md-1 ${style.viewNotification}`}>
                                <div title={"View"}>
                                    <label>View</label>
                                    <p> <i className={`fa fa-eye ${style.eyeView}`} ></i></p>
                                </div>
                        </div>
                    </div> */}


                    <div class={`notification-box ${element.isRead ? "notification-read" : "notification-unread"}`}>
                        <div class="notification-type">
                            <img src={this.getImage(element)} alt="notificationtype" />
                            </div>
                            <div class="notification-text">
                                <label>{element.type} - {dateFormatter(element.created_at)}</label>
                                <p>{element.message}</p>
                            </div>
                            <div class="view-notification">
                                <div title="View">
                                    <label>View</label>
                                    <p> <i class="fa fa-eye"></i></p>
                                </div>
                            </div>
                        </div>


                </div>
            </div>)
      }


    render() {
        // const {
        //     notifications,
        //   } = this.state;
        const notificaitionData = this.props.notificationsData.notifications;
       // console.log("notifications", notifications)
        // if (!this.state.isScreenLoaded) {
        //   return (
        //     <div className="dashboard-loader">
        //       <img src={ttmLoader} alt="loader" className="loader-image" />
        //     </div>
        //   );
        // }
        return (
            <div className={`notification-board ${style.notificationsMainWrapper}`}>
                <div className="row">
                    <div className="col-md-12">
                        <h3>Notifications Board</h3>
                    </div>
                    {/* <div className="col-lg-12 intro-text">
                            <p className="mb-4">
                            </p>
                        </div> */}
                   </div>
                    <div className={style.notificationScreen}>
                    
                        <BootstrapTable
                                bordered={false}
                                remote={true}
                                data={notificaitionData.notification}
                                version="4"
                                search={false}
                                pagination
                                fetchInfo={{
                                    dataTotalSize: this.props.notificationsData.notifications.total?
                                    this.props.notificationsData.notifications.total:0,
                                }}
                                options={{
                                    searchvalue: "",
                                    sortName: this.state.sortName,
                                    sortOrder: this.state.sortOrder,
                                    onSortChange: this.onSortChange,
                                    sizePerPage: 10,
                                    page: this.state.page,
                                    onPageChange: this.onPageChange,
                                    noDataText: this.setLoader(),
                                }}>
                                <TableHeaderColumn
                                    dataField="notification_id"
                                    isKey={true}
                                    dataFormat={(cell, row)=>this.contentformatter(cell, row)}
                                >
                                </TableHeaderColumn>
                            </BootstrapTable>
                    </div>
            </div>
        );
    }
}

// export default Setting;

const mapStateToProps = (state) => {
    return {
        notificationsData: state.notifications,
        readNotificationsData: state.readNotifications
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchNotificationsListing: (page) => dispatch(fetchNotificationsListing(page)),
        readNotifications: (notification_id)=> dispatch(readNotifications(notification_id))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
